import { getOS, OS } from "@/utils/os"
import { useAppSelector } from "@/store"
import { selectIsChromiumBlinkBrowser } from "@/stores/app_slice"
import { useEffect, useRef } from "react"

export function useFixFullScreenCursorStyle(
  viewRef: React.RefObject<HTMLElement>
) {
  const isMac = getOS() === OS.MacOS
  const isChromiumBlinkVal = useAppSelector(selectIsChromiumBlinkBrowser)
  // 先定义一个判断函数
  const isNeedCompatibilityBrowser = () => {
    return isChromiumBlinkVal
  }

  const hasFullScreenElement = () => {
    const fullScreenElement = document.fullscreenElement
    return fullScreenElement !== null && fullScreenElement !== undefined
  }
  const isFullScreen = useRef(hasFullScreenElement())

  useEffect(() => {
    const handleFullScreenChange = () => {
      isFullScreen.current = hasFullScreenElement()
    }
    document.addEventListener("fullscreenchange", handleFullScreenChange)

    const onDispose = () => {
      document.removeEventListener("fullscreenchange", handleFullScreenChange)
    }
    return onDispose
  }, [])

  useEffect(() => {
    let hasAboveTabBar = false
    let hasAboveTabBarWithoutBookmark = false
    const tabBarHeight = window.outerHeight - window.innerHeight
    let isMoveFromTop = false
    let isHandlingMoveFromTop = false
    let recoverTimer: number | null = null

    const recoverCursor = (delay: number, callback?: () => void) => {
      if (viewRef.current) {
        viewRef.current.style.cursor = "default"
      }
      if (recoverTimer !== null) {
        window.clearTimeout(recoverTimer)
      }
      recoverTimer = window.setTimeout(() => {
        if (viewRef.current) {
          viewRef.current.style.cursor = "none"
        }
        recoverTimer = null
        callback?.()
      }, delay)
    }
    const onMouseMove = (e: MouseEvent) => {
      if (!isFullScreen.current || !isMac || !isNeedCompatibilityBrowser()) {
        return
      }

      if (isMoveFromTop) {
        // if (e.clientY >= tabBarHeight - 40) {
        if (e.clientY >= 82) {
          isHandlingMoveFromTop = true
          recoverCursor(200, () => {
            isHandlingMoveFromTop = false
          })
          isMoveFromTop = false
        }

        return
      }

      // tabBarHeight:87
      if (e.clientY <= tabBarHeight && !hasAboveTabBar) {
        hasAboveTabBar = true
        return
      }
      if (e.clientY > tabBarHeight) {
        if (hasAboveTabBar && !isHandlingMoveFromTop) {
          recoverCursor(50)
        }
        hasAboveTabBar = false
      }

      if (e.clientY <= 120 && !hasAboveTabBarWithoutBookmark) {
        hasAboveTabBarWithoutBookmark = true
        return
      }
      if (e.clientY > 120) {
        if (hasAboveTabBarWithoutBookmark && !isHandlingMoveFromTop) {
          recoverCursor(50)
        }
        hasAboveTabBarWithoutBookmark = false
      }
    }

    const onMouseEnter = (e: MouseEvent) => {
      if (!isFullScreen.current || !isMac || !isNeedCompatibilityBrowser()) {
        return
      }

      isMoveFromTop = true
    }

    viewRef.current?.addEventListener("mousemove", onMouseMove)
    viewRef.current?.addEventListener("mouseenter", onMouseEnter)

    const onDispose = () => {
      viewRef.current?.removeEventListener("mousemove", onMouseMove)
      viewRef.current?.removeEventListener("mouseenter", onMouseEnter)

      if (recoverTimer != null) {
        window.clearTimeout(recoverTimer)
        recoverTimer = null
      }
    }
    return onDispose
  }, [isChromiumBlinkVal, isMac, viewRef])
}
